import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faBeerMugEmpty, faPassport, faScrewdriverWrench, faTrophy } from "@fortawesome/free-solid-svg-icons";
import { BadgeType } from "../types/Types";

export function getBadgeIcon(badgeType: BadgeType): IconDefinition {
    switch (badgeType) {
        case BadgeType.CHAMPION:
            return faTrophy;
        case BadgeType.ADMIN:
            return faScrewdriverWrench;
        case BadgeType.SUPPORTER:
            return faBeerMugEmpty;
        case BadgeType.PASSPORT:
            return faPassport;
        default:
            return faTrophy;
    }
}
